import * as actions from './handloomCluster/actions'
import * as mutations from './handloomCluster/mutations'
import * as getters from './handloomCluster/getters'

import { dataProps } from './handloomCluster/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/handloomCluster.js